// extracted by mini-css-extract-plugin
module.exports = {"container":"LearningPathCard_container__3F-6m","containerMobile":"LearningPathCard_containerMobile__1LCG3","infoContainer":"LearningPathCard_infoContainer__3eABZ"};